import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import ScrollToTopButton from '../../components/scroll-to-top-button/scroll-to-top-button';
import LoadingReactor from '../../components/loading-reactor/loading-reactor';
import './bargains.css';

class Bargains extends Component {
    constructor(props) {
        super(props);
        this.state = {
            bargainSearch: "",
            pastBargainSearch: ""
        }
    }

    renderBargains = () => {
        return (
            <>
            <div className="row pt-5 pb-5">
                <div className="col-12 d-flex">
                    <h1 className="text-white display-6 text-decoration-underline">
                        Bargains 
                    </h1>
                    {/* <h1 className="text-success">({this.props.bargains.length})</h1> */}
                    <h1 className="text-success">({this.filteredBargains().length})</h1>
                </div>
                <div className="col-12">
                    <span className="text-secondary">
                        Green names = positive cash asset value. 
                    </span>
                </div>
                <div className="col-12">
                    <span className="text-secondary">
                        Green percentages = less than 70% of NCAV.
                    </span>
                </div>
                <div className="col-12">
                    <span className="text-secondary">
                        Green check = added to favorites.
                    </span>
                </div>
                {/* <div className="col-12 pt-5">
                    <span className="text-white">
                        Sift through this list until you find satisfactory investments.
                    </span>
                </div> */}
                <div className="col-12">
                    <span className="text-secondary">
                        Most recent bargains are listed first.
                    </span>
                </div>
                {/* <div className="col-12">
                    <span className="text-secondary">
                        Recommended to gather a "basket" of these bargains.
                    </span>
                </div> */}
                <div className="col-12">
                    <input type="text" className="form-control bg-dark text-white w-25 mt-5 my-input" id="bargainSearch" placeholder="Search for bargain via symbol..." maxLength="75" 
                        value={this.state.bargainSearch} 
                        onChange={(e) => this.handleBargainSearch(e)}
                    />
                </div>
            </div>

            <div className="row pt-1 pb-5 border-top border-dark">
                {this.filteredBargains().map((bargain, key) => {
                    const bargainPercentage = ((bargain.companySummary.MarketCapitalization / bargain.ncav) * 100).toFixed(2);
                    return (
                        <Link to={{pathname: `/bargain/${bargain.symbol}`}} className="text-decoration-none p-0" key={key}>
                            <div className="container border-bottom border-dark py-1">
                                <div className="row py-3">
                                    <div className="col-12 col-md-2">
                                        <h5 className="text-secondary">{bargain.symbol}</h5>
                                    </div>
                                    <div className="col-12 col-md-3">
                                        {bargain.cashAssetValue > 0 ? <h5 className="text-success text-truncate">{bargain.companySummary.Name}</h5> : <h5 className="text-white text-truncate">{bargain.companySummary.Name}</h5>}
                                    </div>
                                    <div className="col-12 col-md-2">
                                        {bargainPercentage < 70.0 ? <h5 className="text-success fw-bold">{bargainPercentage}%</h5> : <h5 className="text-white fw-bold">{bargainPercentage}%</h5>}
                                    </div>
                                    <div className="col-12 col-md-2">
                                        <h5 className="text-secondary">{bargain.companySummary.Exchange}</h5>
                                    </div>
                                    <div className="col-12 col-md-2">
                                        <h5 className="text-secondary">{bargain.companySummary.Country}</h5>
                                    </div>
                                    {this.props.userData.favorites && this.props.userData.favorites.includes(bargain._id)
                                    ?<div className="col-12 col-md-1 text-success">√</div>
                                    : <div className="col-12 col-md-1"></div>}
                                </div>
                            </div>
                        </Link>
                    )
                })}
            </div>
            </>
        )
    }

    renderPastBargains = () => {
        return (
            <>
            <div className="row pt-5 pb-5">
                <div className="col-12 d-flex">
                    <h1 className="text-white display-6 text-decoration-underline">
                        Past Bargains
                    </h1>
                    <h1 className="text-success">({this.filteredPastBargains().length})</h1>
                </div>
                <div className="col-12">
                    <span className="text-secondary">
                        Companies now selling for more than NCAV, financials older than 6 months, or NCAV thats gone negative. Use extreme caution when/if purchasing any past bargains. This data is provided primarily for educational/historical purposes.
                    </span>
                </div>
                <div className="col-12">
                    <input type="text" className="form-control bg-dark text-white w-25 mt-5 my-input" id="pastBargainSearch" placeholder="Search for past bargain via symbol..." maxLength="75" 
                        value={this.state.pastBargainSearch} 
                        onChange={(e) => this.handlePastBargainSearch(e)}
                    />
                </div>
            </div>

            <div className="row pt-1 pb-5 border-top border-dark">
                {this.filteredPastBargains().map((bargain, key) => {
                    const bargainPercentage = ((bargain.companySummary.MarketCapitalization / bargain.ncav) * 100).toFixed(2);
                    return (
                        <Link to={{pathname: `/bargain/${bargain.symbol}`}} className="text-decoration-none p-0" key={key}>
                            <div className="container border-bottom border-dark py-1">
                                <div className="row py-3">
                                    <div className="col-12 col-md-2">
                                        <h5 className="text-secondary">{bargain.symbol}</h5>
                                    </div>
                                    <div className="col-12 col-md-3">
                                        {bargain.cashAssetValue > 0 ? <h5 className="text-success text-truncate">{bargain.companySummary.Name}</h5> : <h5 className="text-white text-truncate">{bargain.companySummary.Name}</h5>}
                                    </div>
                                    <div className="col-12 col-md-2">
                                        {(bargainPercentage < 70.0 && bargainPercentage > 0) ? <h5 className="text-success fw-bold">{bargainPercentage}%</h5> : <h5 className="text-white fw-bold">{bargainPercentage}%</h5>}
                                    </div>
                                    <div className="col-12 col-md-2">
                                        <h5 className="text-secondary">{bargain.companySummary.Exchange}</h5>
                                    </div>
                                    <div className="col-12 col-md-2">
                                        <h5 className="text-secondary">{bargain.companySummary.Country}</h5>
                                    </div>
                                    {this.props.userData.favorites && this.props.userData.favorites.includes(bargain._id)
                                    ?<div className="col-12 col-md-1 text-success">√</div>
                                    : <div className="col-12 col-md-1"></div>}
                                </div>
                            </div>
                        </Link>
                    )
                })}
            </div>
            </>
        )
    }

    render() {
        if(this.props.bargainsLoading){
            return (
                <div className="container d-flex align-items-center justify-content-center loading-container fade-in-fwd">
                    <LoadingReactor />
                </div>
            )
        } else {
            if(this.props.userLoggedIn === true){
                return (
                    <div id="bargains">
                        <div className="container fade-in-fwd">
                            <div className="row pt-5 pb-3">
                                <div className="col-12 d-flex align-items-center justify-content-end">
                                    <div className="dropdown mx-2">
                                        <button className="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton2" data-bs-toggle="dropdown" aria-expanded="false">
                                            Country ({this.filterCountryName()})
                                        </button>
                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                                            {/* <li><button className="dropdown-item" onClick={() => this.setState({ country: "" })}>All</button></li> */}
                                            <li><button className="dropdown-item" onClick={() => {localStorage.setItem("country", ""); window.location.reload()}}>All</button></li>
                                            {/* <li><button className="dropdown-item" onClick={() => this.setState({ country: "USA" })}>USA</button></li> */}
                                            <li><button className="dropdown-item" onClick={() => {localStorage.setItem("country", "USA"); window.location.reload()}}>USA</button></li>
                                            {/* <li><button className="dropdown-item" onClick={() => this.setState({ country: "China" })}>China</button></li> */}
                                            <li><button className="dropdown-item" onClick={() => {localStorage.setItem("country", "China"); window.location.reload()}}>China</button></li>
                                        </ul>
                                    </div>
                                    <div className="dropdown">
                                        <button className="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                            Exchange ({this.filterExchangeName()})
                                        </button>
                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                            {/* <li><button className="dropdown-item" onClick={() => this.setState({ bargainExchange: "" })}>All</button></li> */}
                                            <li><button className="dropdown-item" onClick={() => {localStorage.setItem("bargainExchange", ""); window.location.reload()}}>All</button></li>
                                            {/* <li><button className="dropdown-item" onClick={() => this.setState({ bargainExchange: "NYSE" })}>NYSE</button></li> */}
                                            <li><button className="dropdown-item" onClick={() => {localStorage.setItem("bargainExchange", "NYSE"); window.location.reload()}}>NYSE</button></li>
                                            {/* <li><button className="dropdown-item" onClick={() => this.setState({ bargainExchange: "NASDAQ" })}>NASDAQ</button></li> */}
                                            <li><button className="dropdown-item" onClick={() => {localStorage.setItem("bargainExchange", "NASDAQ"); window.location.reload()}}>NASDAQ</button></li>
                                            {/* <li><button className="dropdown-item" onClick={() => this.setState({ bargainExchange: "OTC" })}>OTC</button></li> */}
                                            <li><button className="dropdown-item" onClick={() => {localStorage.setItem("bargainExchange", "OTC"); window.location.reload()}}>OTC</button></li>
                                            <li><button className="dropdown-item" onClick={() => {localStorage.setItem("bargainExchange", "PINK"); window.location.reload()}}>PINK</button></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-12 d-flex align-items-center justify-content-end">
                                    {
                                    !localStorage.getItem("bargainType") || localStorage.getItem("bargainType") === "currentBargains"
                                    ?<button className="btn btn-lg btn-outline-success my-2" onClick={() => {localStorage.setItem("bargainType", "pastBargains"); window.location.reload()}}>Past Bargains</button>
                                    :<button className="btn btn-lg btn-success my-2" onClick={() => {localStorage.setItem("bargainType", "currentBargains"); window.location.reload()}}>Bargains</button>
                                    }
                                </div>
                            </div>

                            {
                                !localStorage.getItem("bargainType") || localStorage.getItem("bargainType") === "currentBargains"
                                ? this.renderBargains()
                                : this.renderPastBargains()
                            }
        
                        </div>
                        <ScrollToTopButton/>
                    </div>
                );
            } else {
                return (
                    <div className="container fade-in-fwd my-container-1 d-flex align-items-center justify-content-center">
                        <div className="row p-5">
                            <div className="col-12 text-center">
                                <h1 className="text-white">You must be logged in to view bargains.</h1>
                            </div>
                        </div>
                    </div>
                )
            }
        }
    }

    filteredBargains = () => {
        return this.props.bargains.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).filter(bargain => this.filterBargains(bargain))
    }

    handleBargainSearch = (e) => {
        const upperCaseValue = e.target.value.toUpperCase();
        this.setState({ bargainSearch: upperCaseValue })
    }

    filterBargains = (bargain) => {
        if(this.state.bargainSearch !== "" && bargain.companySummary) {
            const bargainPercentage = ((bargain.companySummary.MarketCapitalization / bargain.ncav) * 100).toFixed(2);
            if (bargain.symbol.includes(this.state.bargainSearch) && bargain.isOutdated === false && bargainPercentage < 100.0 && bargain.ncav > 0) {
                return bargain;
            }
        } else {
            if(bargain.companySummary){
                const bargainPercentage = ((bargain.companySummary.MarketCapitalization / bargain.ncav) * 100).toFixed(2);
                if(bargain.companySummary.Exchange && bargain.companySummary.Country) {
                    if(!localStorage.getItem("bargainExchange") && !localStorage.getItem("country")) {
                        if(bargain.isOutdated === false && bargainPercentage < 100.0 && bargain.ncav > 0) {
                            return bargain
                        }
                    } else if(!localStorage.getItem("bargainExchange") || !localStorage.getItem("country")) {
                        if(!localStorage.getItem("bargainExchange")){
                            if(bargain.isOutdated === false && bargainPercentage < 100.0 && bargain.ncav > 0 && bargain.companySummary.Country.includes(localStorage.getItem("country"))) {
                                return bargain
                            }
                        } else if(!localStorage.getItem("country")) {
                            if(bargain.isOutdated === false && bargainPercentage < 100.0 && bargain.ncav > 0 && bargain.companySummary.Exchange.includes(localStorage.getItem("bargainExchange"))) {
                                return bargain
                            }
                        }
                    } else {
                        if(bargain.isOutdated === false && bargainPercentage < 100.0 && bargain.ncav > 0 && bargain.companySummary.Exchange.includes(localStorage.getItem("bargainExchange")) && bargain.companySummary.Country.includes(localStorage.getItem("country"))) {
                            return bargain
                        }
                    }
                }
            }
        }
    }

    filteredPastBargains = () => {
        return this.props.bargains.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).filter(bargain => this.filterPastBargains(bargain))
    }

    handlePastBargainSearch = (e) => {
        const upperCaseValue = e.target.value.toUpperCase();
        this.setState({ pastBargainSearch: upperCaseValue })
    }

    filterPastBargains = (bargain) => {
        if(this.state.pastBargainSearch !== "" && bargain.companySummary) {
            const bargainPercentage = ((bargain.companySummary.MarketCapitalization / bargain.ncav) * 100).toFixed(2);
            if(bargain.symbol.includes(this.state.pastBargainSearch) && (bargain.isOutdated === true || bargainPercentage > 100.0 || bargain.ncav < 0)) {
                return bargain
            }
        } else {
            if(bargain.companySummary){
                const bargainPercentage = ((bargain.companySummary.MarketCapitalization / bargain.ncav) * 100).toFixed(2);
                if(bargain.companySummary.Exchange && bargain.companySummary.Country) {
                    if(!localStorage.getItem("bargainExchange") && !localStorage.getItem("country")) {
                        if(bargain.isOutdated === true || bargainPercentage > 100.0 || bargain.ncav < 0) {
                            return bargain
                        }
                    } else if(!localStorage.getItem("bargainExchange") || !localStorage.getItem("country")) {
                        if(!localStorage.getItem("bargainExchange")){
                            if((bargain.isOutdated === true || bargainPercentage > 100.0 || bargain.ncav < 0) && bargain.companySummary.Country.includes(localStorage.getItem("country"))) {
                                return bargain
                            }
                        } else if(!localStorage.getItem("country")) {
                            if((bargain.isOutdated === true || bargainPercentage > 100.0 || bargain.ncav < 0) && bargain.companySummary.Exchange.includes(localStorage.getItem("bargainExchange"))) {
                                return bargain
                            }
                        }
                    } else {
                        if((bargain.isOutdated === true || bargainPercentage > 100.0 || bargain.ncav < 0) && bargain.companySummary.Exchange.includes(localStorage.getItem("bargainExchange")) && bargain.companySummary.Country.includes(localStorage.getItem("country"))) {
                            return bargain
                        }
                    }
                }
            }
        }
    }

    filterExchangeName = () => {
        if(localStorage.getItem("bargainExchange") === "" || !localStorage.getItem("bargainExchange")){
            return <span>All</span>
        } else if(localStorage.getItem("bargainExchange") === "NASDAQ"){
            return <span>NASDAQ</span>
        } else {
            return <span>{localStorage.getItem("bargainExchange")}</span>
        }
    }

    filterCountryName = () => {
        if(localStorage.getItem("country") === "" || !localStorage.getItem("country")){
            return <span>All</span>
        } else if (localStorage.getItem("country") === "USA") {
            return <span>USA</span>
        } else {
            return <span>{localStorage.getItem("country")}</span>
        }
    }

}

const mapStateToProps = state => {
    return {
        bargains: state.bargainState.bargains,
        bargainsLoading: state.bargainState.bargainsLoading,
        userLoggedIn: state.userState.userLoggedIn,
        userData: state.userData.userData
    }
}
 
export default connect(mapStateToProps)(Bargains);